import React, { useEffect } from 'react';
import { Grid, Stack, Backdrop, CircularProgress, Snackbar, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Dialog, DialogTitle, DialogContent, Autocomplete, TextField, Typography, Box, Alert, Button, Tooltip, IconButton } from '@mui/material';
import SubCard from 'src/components/cards/SubCard';
import Alert1 from 'src/components/Alert';
import axios from 'src/utils/axios';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import MuiAlert from '@mui/material/Alert';
import { confirmAlert } from 'react-confirm-alert';
import { styled } from '@mui/material/styles';
import 'react-image-crop/dist/ReactCrop.css';
import ImageCrop from 'src/components/ImageCrop/ImageCrop';
import { useTheme } from '@mui/material/styles';


const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    }),
    rootlist: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 550,
    }),
    rootlistsag: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 500,
    }),

    cardBolum: {
        maxHeight: 700,
        minHeight: 700,
        width: '100%'
    },
    table: {
        minWidth: 650,
    },
    content: {
        minHeight: 550,
    },
    chatSection: {
        width: '100%',
    },
    avatar: {
        cursor: 'pointer',
        width: 40,
        height: 40
    },
    headBG: {
        backgroundColor: '#e0e0e0'
    },
    borderRight500: {
        borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
        overflowY: 'auto'
    },
    button: (theme) => ({
        margin: theme.spacing(1),
    }),
    backdrop: (theme) => ({
        zIndex: theme.zIndex.drawer + 1500,
        color: '#fff',
    }),
    actionsCCFile: {
        justifyContent: 'flex-end'
    },
    helperText: (theme) => ({
        color: theme.palette.error.main,
        fontSize: theme.typography.caption.fontSize
    }),
};

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});


const ServicePhotos = ({ ServiceShopId, ServiceShopFullName }) => {
    const [loading, setLoading] = React.useState(true);
    const [alert, setAlert] = React.useState(false);
    const [alertType, setAlertType] = React.useState('success');
    const [alertMessage, setAlertMessage] = React.useState('');
    const [servicePhotoData, setServicePhotoData] = React.useState([]);
    const [servicePhotoCategoryData, setServicePhotoCategoryData] = React.useState([]);
    const [editablePhotoTypeId, setEditablePhotoTypeId] = React.useState(0);
    const [selectedPhotoTypeId, setSelectedPhotoTypeId] = React.useState(0);
    const [selectedPhoto, setSelectedPhoto] = React.useState(null);
    const [showPhotoDialog, setShowPhotoDialog] = React.useState(false);
    const [addPhotoDialog, setAddPhotoDialog] = React.useState(false);
    const [cropImageClicked, setCropImageClicked] = React.useState(false);
    const [updateImageClicked, setUpdateImageClicked] = React.useState(false);
    const [cropUpdatedImageClicked, setCropUpdatedImageClicked] = React.useState(false);
    const [crop, setCrop] = React.useState({
        unit: '%',
        x: 25,
        y: 25,
        width: 50,
        height: 50
    });
    const [imageCropDialog, setImageCropDialog] = React.useState(false);


    //update states
    const [updatedPhotoType, setUpdatedPhotoType] = React.useState('');
    const [updatedPhoto, setUpdatedPhoto] = React.useState(null);
    const [updatedPhotoImg, setUpdatedPhotoImg] = React.useState(null);
    const [croppedUpdatedPhoto, setCroppedUpdatedPhoto] = React.useState(null);

    //add states
    const [newPhotoType, setNewPhotoType] = React.useState('');
    const [newPhoto, setNewPhoto] = React.useState(null);
    const [newPhotoImg, setNewPhotoImg] = React.useState(null);
    const [croppedNewPhoto, setCroppedNewPhoto] = React.useState(null);

    //error states
    const [newPhotoTypeErrorText, setNewPhotoTypeErrorText] = React.useState('');
    const [newPhotoErrorText, setNewPhotoErrorText] = React.useState('');
    const [updatedPhotoErrorText, setUpdatedPhotoErrorText] = React.useState('deneme 123');

    const theme = useTheme();

    useEffect(() => {
        getServicePhotoData();
    }, []);



    const getServicePhotoData = () => {
        setLoading(true);
        axios.get('GetServicePhotoData/' + ServiceShopId)
            .then((response) => {
                setServicePhotoData(response.data.ServicePhotoData);
                setServicePhotoCategoryData(response.data.ServicePhotoCategory);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            }
            );
    }
    const closeAlert = () => {
        setAlert(false);
    }

    const openShowPhotoDialog = (photoTypeId, photo) => {
        setCropUpdatedImageClicked(false);
        setUpdateImageClicked(false);
        setUpdatedPhoto(null);
        setUpdatedPhotoImg(null);
        setCroppedUpdatedPhoto(null);
        setUpdatedPhotoErrorText('');
        setSelectedPhotoTypeId(photoTypeId);
        setSelectedPhoto(`data:image/jpeg;base64,${photo}`);
        setShowPhotoDialog(true);
    }

    const handleEditButtonClick = (photoTypeId) => {
        setEditablePhotoTypeId(photoTypeId);
        setUpdatedPhotoType(servicePhotoCategoryData.filter(x => x.Id === photoTypeId)[0]);
    }

    const handleDeleteButtonClick = (photoType, photoTypeId) => {
        confirmAlert({
            message: photoType + ' Fotoğrafını silmek istediğinize emin misiniz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        setLoading(true);
                        const data = {
                            ServiceShopId: ServiceShopId,
                            Photo: '',
                            PhotoTypeId: photoTypeId,
                            NewPhotoTypeId: 0,
                            Type: 3
                        };
                        axios.post('SetServicePhoto', data)
                            .then((response) => {
                                if (response.data.ErrorCode == 0) {
                                    setAlertType('success');
                                    setAlertMessage('Fotoğraf başarıyla silindi!');
                                }
                                else {
                                    setAlertType('error');
                                    setAlertMessage(response.data.ErrorDescription);
                                }
                                setAlert(true);
                                setLoading(false);
                                getServicePhotoData();
                            })
                            .catch((error) => {
                                setAlert(true);
                                setAlertType('error');
                                setAlertMessage('Fotoğraf silinirken bir hata oluştu!');
                                setLoading(false);
                            });
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => { }
                }
            ]
        });
    }



    const handleSaveButtonClick = () => {
        confirmAlert({
            message: 'Bilgileri güncellemek istediğinize emin misiniz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        setLoading(true);
                        const data = {
                            ServiceShopId: ServiceShopId,
                            Photo: '',
                            PhotoTypeId: editablePhotoTypeId,
                            NewPhotoTypeId: updatedPhotoType.Id,
                            Type: 2
                        };
                        axios.post('SetServicePhoto', data)
                            .then((response) => {
                                if (response.data.ErrorCode == 0) {
                                    setAlertType('success');
                                    setAlertMessage('Fotoğraf başarıyla güncellendi!');
                                }
                                else {
                                    setAlertType('error');
                                    setAlertMessage(response.data.ErrorDescription);
                                }
                                setAlert(true);
                                setLoading(false);
                                getServicePhotoData();
                                setEditablePhotoTypeId(0);
                            })
                            .catch((error) => {
                                setAlert(true);
                                setAlertType('error');
                                setAlertMessage('Fotoğraf güncellenirken bir hata oluştu!');
                                setLoading(false);
                            });
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => { }
                }
            ]
        });
    }

    const handleCancelButtonClick = () => {
        confirmAlert({
            message: 'İşlemi iptal etmek istediğinizden emin misiniz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        setEditablePhotoTypeId(0);
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => { }
                }
            ]
        });
    }

    const handleAddButtonClick = () => {
        setNewPhotoErrorText('');
        setNewPhotoTypeErrorText('');

        var error = false;
        if (!newPhotoType) {
            setNewPhotoTypeErrorText('Fotoğraf tipi seçiniz!');
            error = true;
        }
        if (!newPhoto) {
            setNewPhotoErrorText('Foto seçiniz!');
            error = true;
        }
        if (error) {
            return;
        }

        confirmAlert({
            message: 'Yeni fotoğraf eklemek istediğinize emin misiniz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        handeAddButtonConfirm();
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => { }
                }
            ]
        });
    }
    const handeAddButtonConfirm = async () => {
        setLoading(true);
        const base64Photo = croppedNewPhoto ? await convertBlobUrlToBase64(croppedNewPhoto) : await convertToBase64(newPhoto);
        const data = {
            ServiceShopId: ServiceShopId,
            Photo: base64Photo,
            PhotoTypeId: 0,
            NewPhotoTypeId: newPhotoType.Id,
            Type: 1
        };
        axios.post('SetServicePhoto', data)
            .then((response) => {
                if (response.data.ErrorCode == 0) {
                    setAlertType('success');
                    setAlertMessage('Fotoğraf başarıyla eklendi!');
                }
                else {
                    setAlertType('error');
                    setAlertMessage(response.data.ErrorDescription);
                }
                setAlert(true);
                setLoading(false);
                getServicePhotoData();
                setAddPhotoDialog(false);
            })
            .catch((error) => {
                setAlert(true);
                setAlertType('error');
                setAlertMessage('Fotoğraf eklenirken bir hata oluştu!');
                setLoading(false);
                setAddPhotoDialog(false);
            });
    }



    const convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result;
                // Base64 string'in data kısmını alma
                const base64Data = base64String.split(',')[1];
                resolve(base64Data);
            };
            reader.onerror = error => reject(error);
        });
    };

    const convertBlobUrlToBase64 = async (blobUrl) => {
        const response = await fetch(blobUrl);
        const blob = await response.blob();

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64String = reader.result;
                const base64Data = base64String.split(',')[1];
                resolve(base64Data);
            };
            reader.onerror = error => reject(error);
        });
    };

    const handleCropComplete = () => {
        setLoading(true);
        cropImage(newPhotoImg, crop)
            .then((croppedURL) => {
                window.URL.revokeObjectURL(croppedNewPhoto);
                setCroppedNewPhoto(croppedURL);
                setCropImageClicked(false);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Image cropping failed', error);
                setLoading(false);
            });
    }

    const cropImage = (newPhotoImg, crop) => {
        return new Promise((resolve, reject) => {
            const image = document.createElement('img');
            image.src = newPhotoImg;

            image.onload = () => {
                const canvas = document.createElement('canvas');
                const scaleX = image.naturalWidth / image.width;
                const scaleY = image.naturalHeight / image.height;
                canvas.width = crop.width;
                canvas.height = crop.height;
                const ctx = canvas.getContext('2d');

                ctx.drawImage(
                    image,
                    crop.x * scaleX,
                    crop.y * scaleY,
                    crop.width * scaleX,
                    crop.height * scaleY,
                    0,
                    0,
                    crop.width,
                    crop.height
                );

                canvas.toBlob((blob) => {
                    if (!blob) {
                        console.error('Canvas is empty');
                        reject(new Error('Canvas is empty'));
                        return;
                    }
                    blob.name = newPhoto.name;
                    const croppedURL = window.URL.createObjectURL(blob);
                    resolve(croppedURL);
                }, 'image/jpeg');
            };

            image.onerror = (error) => {
                reject(error);
            };
        });
    };

    const handleCropButtonClick = (photo) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            setNewPhotoImg(reader.result);
            setImageCropDialog(true);
            setCropImageClicked(true);
        });
        reader.readAsDataURL(photo);
        setCrop({
            unit: '%', // Can be 'px' or '%'
            x: 25,
            y: 25,
            width: 50,
            height: 50
        });
    }

    const handleCropUpdatedImageClicked = (photo) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            setUpdatedPhotoImg(reader.result);
            setImageCropDialog(true);
            setCropImageClicked(true);
        });
        reader.readAsDataURL(photo);
        setCrop({
            unit: '%', // Can be 'px' or '%'
            x: 25,
            y: 25,
            width: 50,
            height: 50
        });
        setCropUpdatedImageClicked(true);
    }

    const cropUpdatedImage = (updatedPhotoImg, crop) => {
        return new Promise((resolve, reject) => {
            const image = document.createElement('img');
            image.src = updatedPhotoImg;

            image.onload = () => {
                const canvas = document.createElement('canvas');
                const scaleX = image.naturalWidth / image.width;
                const scaleY = image.naturalHeight / image.height;
                canvas.width = crop.width;
                canvas.height = crop.height;
                const ctx = canvas.getContext('2d');

                ctx.drawImage(
                    image,
                    crop.x * scaleX,
                    crop.y * scaleY,
                    crop.width * scaleX,
                    crop.height * scaleY,
                    0,
                    0,
                    crop.width,
                    crop.height
                );

                canvas.toBlob((blob) => {
                    if (!blob) {
                        console.error('Canvas is empty');
                        reject(new Error('Canvas is empty'));
                        return;
                    }
                    blob.name = updatedPhoto.name;
                    const croppedURL = window.URL.createObjectURL(blob);
                    resolve(croppedURL);
                }, 'image/jpeg');
            };

            image.onerror = (error) => {
                reject(error);
            };
        });
    }

    const handleUpdateCropComplete = () => {
        setLoading(true);
        cropUpdatedImage(updatedPhotoImg, crop)
            .then((croppedURL) => {
                window.URL.revokeObjectURL(croppedNewPhoto);
                setCroppedUpdatedPhoto(croppedURL);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Image cropping failed', error);
                setLoading(false);
            });
        setCropUpdatedImageClicked(false);
    }

    const handleUpdatePhotoButtonClick = () => {
        setUpdatedPhotoErrorText('');
        if (!updatedPhoto) {
            setUpdatedPhotoErrorText('Lütfen fotoğraf yükleyiniz!');
            return;
        }
        confirmAlert({
            message: 'Bilgileri güncellemek istediğinize emin misiniz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        confirmUpdatePhoto();
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => { }
                }
            ]
        });
    }

    const confirmUpdatePhoto = async () => {
        setLoading(true);
        const base64Photo = croppedUpdatedPhoto ? await convertBlobUrlToBase64(croppedUpdatedPhoto) : await convertToBase64(updatedPhoto);
        const data = {
            ServiceShopId: ServiceShopId,
            Photo: base64Photo,
            PhotoTypeId: selectedPhotoTypeId,
            NewPhotoTypeId: 0,
            Type: 4
        };
        axios.post('SetServicePhoto', data)
            .then((response) => {
                if (response.data.ErrorCode == 0) {
                    setAlertType('success');
                    setAlertMessage('Fotoğraf başarıyla güncellendi!');
                }
                else {
                    setAlertType('error');
                    setAlertMessage(response.data.ErrorDescription);
                }
                setAlert(true);
                setLoading(false);
                getServicePhotoData();
                setShowPhotoDialog(false);
            })
            .catch((error) => {
                setAlert(true);
                setAlertType('error');
                setAlertMessage('Fotoğraf güncellenirken bir hata oluştu!');
                setLoading(false);
                setShowPhotoDialog(false);
            });
    }

    const handleImageCropDialogClose = () => {
        setImageCropDialog(false);
        setCropImageClicked(false);
        setCropUpdatedImageClicked(false);
    }

    const Base64Button = ({ PhotoId, base64Image }) => {
        const base64ImageString = 'data:image/png;base64,' + base64Image;
        return (
            <Button
                variant="outlined"
                onClick={() => {
                    openShowPhotoDialog(PhotoId, base64Image);
                }}
                style={{
                    display: "flex",
                    position: "relative",
                    justifyContent: "center",
                    alignItems: "center",
                    borderColor: "#FF9800",
                    borderWidth: 2,
                }}
            >
                <img
                    src={base64ImageString}
                    style={{ height: "80px", width: "160px", objectFit: "cover" }}
                />
                <span
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        color: "white",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        padding: "10px", // Daha fazla boşluk için arttırıldı
                        borderRadius: "50%",
                        margin: "2px", // İkon etrafında boşluk için
                    }}
                >
                    <EditIcon style={{ fontSize: '23px', color: '#eeeeee' }} />
                </span>
            </Button>
        );
    };





    return (
        <Grid container spacing={3}>
            <Backdrop sx={styles.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar open={alert} autoHideDuration={10000} onClose={closeAlert}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}>
                <Alert1 onClose={closeAlert} variant={alertType} message={alertMessage}>
                </Alert1>
            </Snackbar>
            <Grid
                size={{
                    xs: 12,
                    md: 12,
                    lg: 12
                }}>
                <SubCard title={
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid
                            justifyContent="center"
                            alignItems="center"
                            size={{
                                xs: 6,
                                md: 6,
                                lg: 6
                            }}>
                            {ServiceShopFullName}
                        </Grid>
                        <Grid
                            size={{
                                xs: 6,
                                md: 6,
                                lg: 6
                            }}>
                            <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={() => {
                                        setNewPhotoType('');
                                        setNewPhoto(null);
                                        setNewPhotoImg(null);
                                        setCroppedNewPhoto(null);
                                        setNewPhotoErrorText('');
                                        setNewPhotoTypeErrorText('');
                                        setAddPhotoDialog(true);
                                    }}
                                >
                                    Ekle
                                    <AddCircleIcon style={{ marginLeft: '5px' }} />
                                </Button>
                            </Stack>
                        </Grid>
                    </Grid>
                }>
                    <TableContainer component={Paper}>
                        <Table stickyHeader aria-label="sticky table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell>FOTOĞRAF TİPİ</TableCell>
                                    <TableCell>FOTOĞRAF</TableCell>
                                    <TableCell>İŞLEM</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {servicePhotoData && servicePhotoData.map((row) => (
                                    <TableRow key={row.PhotoTypeId}>
                                        <TableCell>
                                            {editablePhotoTypeId === row.PhotoTypeId ?
                                                <Autocomplete
                                                    id="combo-box-demo"
                                                    options={servicePhotoCategoryData}
                                                    value={updatedPhotoType}
                                                    getOptionLabel={(option) => option.Dsc || ''}
                                                    style={{ width: 300 }}
                                                    renderInput={(params) => <TextField
                                                        {...params}
                                                        size='small'
                                                        variant="outlined"
                                                    />}
                                                    onChange={(event, newValue) => {
                                                        setUpdatedPhotoType(newValue);
                                                    }}
                                                />
                                                :
                                                row.PhotoType
                                            }
                                        </TableCell>
                                        <TableCell>
                                            <Base64Button PhotoId={row.PhotoTypeId} base64Image={row.Photo} />
                                        </TableCell>
                                        <TableCell>
                                            {editablePhotoTypeId === row.PhotoTypeId ?
                                                <>
                                                    <Tooltip title="Kaydet">
                                                        <IconButton
                                                            size="large"
                                                            onClick={() => {
                                                                handleSaveButtonClick();
                                                            }}
                                                        >
                                                            <SaveIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="İptal">
                                                        <IconButton
                                                            size="large"
                                                            onClick={() => {
                                                                handleCancelButtonClick();
                                                            }}
                                                        >
                                                            <CancelIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </>
                                                :
                                                <>
                                                    <Tooltip title="Düzenle">
                                                        <IconButton
                                                            size="large"
                                                            onClick={() => {
                                                                handleEditButtonClick(row.PhotoTypeId);
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Sil">
                                                        <IconButton
                                                            size="large"
                                                            onClick={() => {
                                                                handleDeleteButtonClick(row.PhotoType, row.PhotoTypeId);
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </>
                                            }

                                        </TableCell>
                                    </TableRow >

                                ))}


                            </TableBody>
                        </Table>
                    </TableContainer>
                </SubCard>
                <Dialog
                    open={showPhotoDialog}
                    onClose={() => {
                        setShowPhotoDialog(false);
                    }}
                >
                    <DialogTitle
                        size="small"
                        id="responsive-dialog-title"
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <div>{selectedPhotoTypeId !== 0 ? servicePhotoCategoryData.filter(x => x.Id === selectedPhotoTypeId)[0].Dsc : ''} Fotoğrafı
                        </div>
                        <IconButton
                            edge="end"
                            size="small"
                            color="inherit"
                            onClick={() => {
                                setSelectedPhotoTypeId(0);
                                setSelectedPhoto(null);
                                setShowPhotoDialog(false);
                                setUpdateImageClicked(false);
                                setCropImageClicked(false);
                            }}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={3} justifyContent="center" alignItems="center">

                            {cropUpdatedImageClicked && updatedPhotoImg ? (
                                <ImageCrop
                                    image={updatedPhotoImg}
                                    setNewImage={setCroppedUpdatedPhoto}
                                    open={imageCropDialog}
                                    handleClose={handleImageCropDialogClose}
                                />
                            ) : croppedUpdatedPhoto ? (
                                <Grid
                                    justifyContent="center"
                                    alignItems="center"
                                    textAlign="center"
                                    size={{
                                        xs: 12,
                                        md: 12,
                                        lg: 12
                                    }}>
                                    <img
                                        src={croppedUpdatedPhoto}
                                        style={{ maxWidth: '100%', maxHeight: '100%' }}
                                    />
                                    <br />
                                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                        {updatedPhoto.name}
                                    </Typography>
                                    <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                handleCropUpdatedImageClicked(updatedPhoto);
                                            }}
                                        >
                                            <EditIcon />
                                        </IconButton>
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                setUpdatedPhoto(null);
                                                setUpdatedPhotoImg(null);
                                                setCroppedUpdatedPhoto(null);
                                            }}
                                        >
                                            <DeleteForeverIcon />
                                        </IconButton>
                                    </Stack>
                                </Grid>
                            ) :
                                updateImageClicked ? (
                                    <Grid
                                        justifyContent="center"
                                        alignItems="center"
                                        textAlign="center"
                                        size={{
                                            xs: 12,
                                            md: 12,
                                            lg: 12
                                        }}>
                                        <Stack direction="column" spacing={2} justifyContent="center" alignItems="center">
                                            <Button
                                                component="label"
                                                variant="contained"
                                                color="secondary"
                                                startIcon={<CloudUploadIcon />}
                                            >
                                                Fotoğraf Yükle
                                                <VisuallyHiddenInput
                                                    type="file"
                                                    accept='image/*'
                                                    onChange={(e) => {
                                                        setUpdatedPhoto(e.target.files[0]);
                                                    }}
                                                />
                                            </Button>
                                            {updatedPhoto ? (
                                                <>
                                                    <img
                                                        src={URL.createObjectURL(updatedPhoto)}
                                                        style={{ maxWidth: '100%', maxHeight: '100%' }}
                                                    />
                                                    <br />
                                                    <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                        {updatedPhoto.name}
                                                    </Typography>
                                                    <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                handleCropUpdatedImageClicked(updatedPhoto);
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => {
                                                                setUpdatedPhoto(null);
                                                            }}
                                                        >
                                                            <DeleteForeverIcon />
                                                        </IconButton>
                                                    </Stack>
                                                </>

                                            ) : <>
                                                <ImageNotSupportedIcon style={{ fontSize: 100, }} />
                                                {updatedPhotoErrorText ? (
                                                    <MuiAlert severity="error" style={{ marginBottom: 10 }}>
                                                        {updatedPhotoErrorText}
                                                    </MuiAlert>
                                                ) : null
                                                }
                                            </>
                                            }
                                        </Stack>
                                    </Grid>
                                ) : (

                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 12,
                                            lg: 12
                                        }}>
                                        <div style={{
                                            width: '100%',
                                            height: '100%',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}>
                                            <img
                                                src={selectedPhoto}
                                                alt={'Fotoğraf'}
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: '100%',
                                                    objectFit: 'contain',
                                                }}
                                                onClick={() => handleOpenImage(vehiclePhoto)}
                                            />
                                        </div>
                                    </Grid>
                                )}
                            <Grid
                                justifyContent="center"
                                alignItems="center"
                                textAlign="center"
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12
                                }}>
                                {updateImageClicked ? (
                                    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            fullWidth
                                            onClick={() => {
                                                handleUpdatePhotoButtonClick();
                                            }}
                                        >
                                            Güncelle
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            fullWidth
                                            onClick={() => {
                                                setUpdateImageClicked(false);
                                                setUpdatedPhoto(null);
                                            }}
                                        >
                                            İptal
                                        </Button>
                                    </Stack>
                                ) : (
                                    <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            fullWidth
                                            onClick={() => {
                                                setUpdateImageClicked(true);
                                            }}
                                        >
                                            Yeni Foto Ekle
                                        </Button>
                                        {/* <Button
                                                variant="contained"
                                                color="secondary"
                                                fullWidth
                                                onClick={() => {
                                                    setCropImageClicked(true);
                                                }}
                                            >
                                                Fotoyu Düzenle
                                            </Button> */}
                                    </Stack>
                                )}
                                <br></br>
                                <Grid size={12}>
                                    <Grid container justifyContent="center">
                                        <Box>
                                            <Alert variant="outlined" severity="info" sx={{ borderColor: theme.palette.info.dark }}>
                                                Fotoğraf değişiklikleri 1 gün sonra yansımaktadır.
                                            </Alert>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={addPhotoDialog}
                    onClose={() => {
                        setAddPhotoDialog(false);
                    }}
                >
                    <DialogTitle
                        size="small"
                        id="responsive-dialog-title"
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <div>
                            Fotoğraf Ekle
                        </div>
                        <IconButton
                            edge="end"
                            size="small"
                            color="inherit"
                            onClick={() => {
                                setAddPhotoDialog(false);
                            }}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={3} justifyContent="center" alignItems="center" paddingTop={1}>
                            <Grid
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12
                                }}>
                                <Autocomplete
                                    id="combo-box-demo"
                                    options={servicePhotoCategoryData}
                                    value={newPhotoType}
                                    getOptionLabel={(option) => option.Dsc || ''}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Fotoğraf Tipi"
                                        error={newPhotoTypeErrorText !== ''}
                                        helperText={newPhotoTypeErrorText}
                                    />}
                                    onChange={(event, newValue) => {
                                        setNewPhotoType(newValue);
                                    }}
                                />
                            </Grid>
                            {!cropImageClicked ? (
                                <Grid
                                    justifyContent="center"
                                    alignItems="center"
                                    textAlign="center"
                                    size={{
                                        xs: 12,
                                        md: 12,
                                        lg: 12
                                    }}>
                                    <Button
                                        component="label"
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<CloudUploadIcon />}
                                    >
                                        {!newPhoto ? 'Fotoğraf Yükle' : 'Fotoğrafı Değiştir'}
                                        <VisuallyHiddenInput
                                            type="file"
                                            accept='image/*'
                                            onChange={(e) => {
                                                setNewPhoto(e.target.files[0]);
                                            }}
                                        />
                                    </Button>
                                </Grid>) : null}
                            {cropImageClicked ? (
                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 12,
                                        lg: 12
                                    }}>
                                    <ImageCrop
                                        image={newPhotoImg}
                                        setNewImage={setCroppedNewPhoto}
                                        open={imageCropDialog}
                                        handleClose={handleImageCropDialogClose}
                                    />
                                </Grid>

                            )
                                : croppedNewPhoto ? (
                                    <Grid
                                        justifyContent="center"
                                        alignItems="center"
                                        textAlign="center"
                                        size={{
                                            xs: 12,
                                            md: 12,
                                            lg: 12
                                        }}>
                                        <img
                                            src={croppedNewPhoto}
                                            style={{ maxWidth: '100%', maxHeight: '100%' }}
                                        />
                                        <br />
                                        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                            {newPhoto.name}
                                        </Typography>
                                        <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    handleCropButtonClick(newPhoto);
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton
                                                size="small"
                                                onClick={() => {
                                                    setNewPhoto(null);
                                                    setNewPhotoImg(null);
                                                    setCroppedNewPhoto(null);
                                                }}
                                            >
                                                <DeleteForeverIcon />
                                            </IconButton>
                                        </Stack>
                                        {newPhotoErrorText ? (

                                            <Typography sx={styles.helperText} marginTop={5}>
                                                {newPhotoErrorText}
                                            </Typography>
                                        ) : null}
                                    </Grid>
                                ) :
                                    newPhoto ? (
                                        <Grid
                                            justifyContent="center"
                                            alignItems="center"
                                            textAlign="center"
                                            size={{
                                                xs: 12,
                                                md: 12,
                                                lg: 12
                                            }}>
                                            <img
                                                src={URL.createObjectURL(newPhoto)}
                                                style={{ maxWidth: '100%', maxHeight: '100%' }}
                                            />
                                            <br />
                                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                {newPhoto.name}
                                            </Typography>
                                            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        handleCropButtonClick(newPhoto);
                                                    }}
                                                >
                                                    <EditIcon />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                        setNewPhoto(null);
                                                        setNewPhotoImg(null);
                                                        setCroppedNewPhoto(null);
                                                    }}
                                                >
                                                    <DeleteForeverIcon />
                                                </IconButton>
                                            </Stack>
                                            {newPhotoErrorText ? (

                                                <Typography style={{
                                                    color: 'red',
                                                    marginTop: 5
                                                }}>
                                                    {newPhotoErrorText}
                                                </Typography>
                                            ) : null}
                                        </Grid>
                                    ) : newPhotoErrorText ? (

                                        <Typography style={{
                                            color: 'red',
                                            marginTop: 5
                                        }}>
                                            {newPhotoErrorText}
                                        </Typography>
                                    ) : null}

                            <Grid
                                justifyContent="center"
                                alignItems="center"
                                textAlign="center"
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12
                                }}>
                                {
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        fullWidth
                                        onClick={() => {
                                            handleAddButtonClick();
                                        }}
                                    >
                                        Ekle
                                    </Button>
                                }

                            </Grid>
                        </Grid>
                        <br></br>
                        <Box>
                            <Grid container spacing={1}>
                                <Grid size={12}>
                                    <Alert variant="outlined" severity="info" sx={{ borderColor: theme.palette.info.dark }}>
                                        Fotoğraf değişiklikleri 1 gün sonra yansımaktadır.
                                    </Alert>
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>
                </Dialog>
            </Grid>
        </Grid>
    );
};

export default ServicePhotos;